import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MaterialModule } from 'src/app/material.module';
import { CardComponent } from './card/card.component';
import { CardsComponent } from './cards/cards.component';
import { ProgressIndictatorsModule } from '../progress-indicators/progress-indicators.module';
import { LazyLoadImageModule } from 'ng-lazyload-image';
import { DirectivesModule } from '../../directives/directives.module';


@NgModule({
  imports: [
    CommonModule,
    LazyLoadImageModule,
    MaterialModule,
    ProgressIndictatorsModule,
    DirectivesModule
  ],
  declarations: [
    CardComponent,
    CardsComponent
  ],
  exports: [
    CardComponent,
    CardsComponent
  ]
})
export class CardsModule { }
